import { Controller } from "@hotwired/stimulus"

// Filters client dropdowns and loads attempt options via JSON when a client is selected.
export default class extends Controller {
  static targets = ["clientA", "clientB", "attemptA", "attemptB"]
  static values = { optionsUrl: String }

  connect() {
    if (!this.hasClientATarget) return

    this.filterClientBOptions()
    this.filterClientAOptions()
  }

  onClientAChange() {
    this.loadAttemptOptions(this.attemptATarget, this.clientATarget.value)
    this.filterClientBOptions()
    if (this.clientBTarget.value === this.clientATarget.value) {
      this.clientBTarget.value = ""
      this.resetAttemptSelect(this.attemptBTarget)
    }
  }

  onClientBChange() {
    this.loadAttemptOptions(this.attemptBTarget, this.clientBTarget.value)
    this.filterClientAOptions()
    if (this.clientATarget.value === this.clientBTarget.value) {
      this.clientATarget.value = ""
      this.resetAttemptSelect(this.attemptATarget)
    }
  }

  onAttemptAChange() {
    const selectedOption = this.attemptATarget.querySelector(`option[value="${this.attemptATarget.value}"]`)
    const clientId = selectedOption?.dataset.clientId
    if (clientId && this.clientATarget.value !== clientId) {
      this.clientATarget.value = clientId
      this.filterClientBOptions()
    }
  }

  onAttemptBChange() {
    const selectedOption = this.attemptBTarget.querySelector(`option[value="${this.attemptBTarget.value}"]`)
    const clientId = selectedOption?.dataset.clientId
    if (clientId && this.clientBTarget.value !== clientId) {
      this.clientBTarget.value = clientId
      this.filterClientAOptions()
    }
  }

  async loadAttemptOptions(selectElement, clientId) {
    this.resetAttemptSelect(selectElement)
    if (!clientId || !this.hasOptionsUrlValue) return

    try {
      const url = new URL(this.optionsUrlValue, window.location.origin)
      url.searchParams.set("client_id", clientId)
      const response = await fetch(url, { headers: { Accept: "application/json" } })
      if (!response.ok) return

      const data = await response.json()
      data.attempts.forEach((attempt) => {
        const option = document.createElement("option")
        option.value = attempt.id
        option.dataset.clientId = attempt.client_id
        if (attempt.completed_at) option.dataset.completedAt = attempt.completed_at
        option.textContent = attempt.label
        selectElement.appendChild(option)
      })
    } catch {
      // ignore network errors
    }
  }

  resetAttemptSelect(selectElement) {
    const placeholder = selectElement.querySelector("option[value='']")
    const placeholderText = placeholder?.textContent || ""
    selectElement.innerHTML = ""
    const emptyOption = document.createElement("option")
    emptyOption.value = ""
    emptyOption.textContent = placeholderText
    selectElement.appendChild(emptyOption)
  }

  filterClientBOptions() {
    this.filterClientOptions(this.clientBTarget, this.clientATarget.value)
  }

  filterClientAOptions() {
    this.filterClientOptions(this.clientATarget, this.clientBTarget.value)
  }

  filterClientOptions(selectElement, excludeId) {
    const options = selectElement.querySelectorAll("option[value]")
    options.forEach((opt) => {
      opt.hidden = opt.value && opt.value === excludeId
    })
  }
}
